<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-8 text-center">
          <v-icon color="success" size="64" class="mb-4">
            mdi-email-check
          </v-icon>
          
          <v-card-title class="text-h5 mb-4 text-center">
            Регистрация завершена
          </v-card-title>
          
          <v-card-text class="text-body-1 mb-4">
            Регистрация прошла успешно! Мы отправили письмо с подтверждением на вашу почту. 
            Пожалуйста, проверьте ваш почтовый ящик и перейдите по ссылке для подтверждения регистрации.
          </v-card-text>
          
          <v-alert 
            type="info" 
            variant="tonal" 
            class="mb-4 text-start"
          >
            <strong>Важно:</strong> Если письмо не пришло, проверьте папку "Спам" или "Нежелательная почта"
          </v-alert>
          
          <!-- Resend email section -->
          <v-divider class="mb-4"></v-divider>
          
          <v-card-text v-if="!canResend" class="text-body-2 text-grey">
            Письмо не дошло? Запросить еще раз через {{ formatTime(countdown) }}
          </v-card-text>
          
          <v-btn
            v-if="canResend"
            color="secondary"
            variant="text"
            @click="resendEmail"
            :loading="isResending"
            class="mb-4"
          >
            Отправить письмо повторно
          </v-btn>
          
          <v-alert
            v-if="resendMessage"
            :type="resendError ? 'error' : 'success'"
            variant="tonal"
            closable
            class="mb-4 text-start"
            @click:close="resendMessage = ''"
          >
            {{ resendMessage }}
          </v-alert>
          
          <v-btn
            color="primary"
            size="large"
            variant="elevated"
            :to="'/signin'"
            block
          >
            Перейти к входу
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from '@/apiClient';

export default {
  name: 'UserRegistered',
  data() {
    return {
      countdown: 60, // 60 seconds countdown
      canResend: false,
      isResending: false,
      resendMessage: '',
      resendError: false,
      intervalId: null,
      userEmail: null
    };
  },
  mounted() {
    // Get email from query params or session storage
    this.userEmail = this.$route.query.email || sessionStorage.getItem('registeredEmail');
    
    // Start countdown
    this.startCountdown();
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    startCountdown() {
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.canResend = true;
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    async resendEmail() {
      if (!this.userEmail) {
        this.resendMessage = 'Email адрес не найден. Пожалуйста, зарегистрируйтесь заново.';
        this.resendError = true;
        return;
      }
      
      this.isResending = true;
      this.resendMessage = '';
      
      try {
        const response = await apiClient.post('/resend-verification', {
          email: this.userEmail
        });
        
        if (response.status === 200) {
          this.resendMessage = 'Письмо успешно отправлено! Проверьте вашу почту.';
          this.resendError = false;
          
          // Reset countdown
          this.countdown = 60;
          this.canResend = false;
          this.startCountdown();
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.resendMessage = error.response.data.detail || 'Ошибка при отправке письма';
        } else {
          this.resendMessage = 'Ошибка при отправке письма. Попробуйте позже.';
        }
        this.resendError = true;
      } finally {
        this.isResending = false;
      }
    }
  }
}
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
